<script setup lang="ts">
interface Option {
  value: string;
  label: string;
  tooltip?: string;
  disabled?: boolean;
  action?: (value: string) => void;
}

interface Props {
  modelValue?: string;
  options?: Option[];
  optionsType?: string;
}

const props = withDefaults(defineProps<Props>(), {
  options: () => [],
  optionsType: '',
});

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void;
}>();

function doOptionButtonClick(option: Option) {
  console.log('[FormOptionButtons] click:', option.value, 'current:', props.modelValue);
  emit('update:modelValue', option.value);
  option.action?.(option.value);
}
</script>

<template>
  <div class="uk-flex">
    <form-group
      v-for="(option, index) in options"
      :key="`${optionsType}_${option.value}`"
      :class="{
        [`uk-width-1-${options?.length}`]: true,
      }"
    >
      <button
        type="button"
        class="uk-button uk-width-1-1 capitalize"
        data-cy="form-option-button"
        :data-tid="option.value === 'Opposition' ? 'invite-critique' : 'make-critique'"
        :class="{
          'right-border-rounded': index % 2 === 0,
          'left-border-rounded': index % 2 !== 0,
          'uk-button-secondary': option.value === modelValue,
          'uk-button-default': option.value !== modelValue,
        }"
        style="border: 1px solid #516d79"
        :value="option.value"
        :uk-tooltip="option.tooltip"
        :disabled="option.disabled"
        @click="doOptionButtonClick(option)"
      >
        {{ option.label }}
      </button>
    </form-group>
  </div>
</template>

<style lang="scss">
.capitalize {
  text-transform: none !important;
}

.right-border-rounded {
  border-radius: 6px 0 0 6px !important;
}

.left-border-rounded {
  border-radius: 0 6px 6px 0 !important;
}
</style>
